/* @flow */
import * as React from 'react';

import EventTracking from 'lib/EventTracking';

import ErrorReporter from 'app/components/ErrorReporter.jsx';

import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Text from 'components/Text.jsx';
import List from 'components/List.jsx';
import ListItem from 'components/ListItem.jsx';
import Heading from 'components/Heading.jsx';

type NoMaybeMeType = $NonMaybeType<$ElementType<IndividualPlanViewQuery, 'me'>>;
type IndividualPlansType = $ElementType<$ElementType<NoMaybeMeType, 'individualPlans'>, number>;
type PlanUnionType = $ElementType<IndividualPlansType, 0>;
type FreeIndividualPlanType = $ElementType<PlanUnionType, 0>;
type PlanProductDetailsType = $ElementType<
  $ElementType<FreeIndividualPlanType, 'productDetails'>,
  number
>;

type Props = {
  hasFreePlan: boolean,
  freeIndividualPlan?: FreeIndividualPlanType,
};

class FreePlanView extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('individual_plans.plan_view.free_plan.view');
  }

  renderFreePlanSections = (hasFreePlan: boolean, freeIndividualPlan?: FreeIndividualPlanType) => {
    const freePlanSection =
      freeIndividualPlan && freeIndividualPlan.productDetails ? (
        <Box
          title={this.renderHeader(freeIndividualPlan.activeSince, hasFreePlan)}
          dark
          headerSize="xsmall">
          <BoxBody size="small">
            {this.renderProductDetails(freeIndividualPlan.productDetails)}
          </BoxBody>
        </Box>
      ) : (
        <ErrorReporter error="IndividualPlanContainer - tried to render without a user" />
      );

    return freePlanSection;
  };

  renderHeader = (freePlanActiveDate: string, hasFreePlan: boolean) => {
    return (
      <MediaObject center figure="right">
        <MediaObject center figure="left">
          <Text size="medium" weight="semibold">
            Free Plan
          </Text>
          {hasFreePlan && (
            <Text align="left" color="eclipse" size="small">
              {freePlanActiveDate}
            </Text>
          )}
        </MediaObject>
        {hasFreePlan && (
          <Text color="pitch" size="medium">
            You are currently on this plan
          </Text>
        )}
      </MediaObject>
    );
  };

  renderProductDetails = (freePlanSpecs?: Array<PlanProductDetailsType>) => {
    const listItems = freePlanSpecs ? (
      freePlanSpecs.map(item => (
        <ListItem>
          <Text size="small">{item.text}</Text>
        </ListItem>
      ))
    ) : (
      <Text size="medium" color="lava">
        Error loading features at this time
      </Text>
    );

    return (
      <React.Fragment>
        <Heading align="left" level="3">
          Features
        </Heading>
        <List marker="bullet" markerPosition="inside">
          {listItems}
        </List>
      </React.Fragment>
    );
  };

  render() {
    const { hasFreePlan, freeIndividualPlan } = this.props;
    return <div>{this.renderFreePlanSections(hasFreePlan, freeIndividualPlan)}</div>;
  }
}

export default FreePlanView;
